@let track = trackEntry();
@let allProjects = projects();

@if (track) {
<form [formGroup]="form" class="track-entry">
  @if (!track.permissions.update) {
  <mat-icon matPrefix class="track-entry__project-icon">lock</mat-icon>
  }
  <mat-form-field appearance="fill" class="track-entry__title">
    <input #nameInput matInput formControlName="title" type="text" [value]="track.title"
      class="track-entry__title-input">
  </mat-form-field>

  @if (allProjects) {
  <mat-form-field appearance="fill" class="track-entry__project">
    <mat-icon matPrefix class="track-entry__project-icon">folder</mat-icon>
    <mat-select formControlName="selectedProject" class="track-entry__project-select">
      @for (project of allProjects; track project.id) {
      <mat-option [value]="project.id" [disabled]="!project.permissions.track" class="track-entry__project-option">
        {{project.name}}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>
  } @else {
  <span class="track-entry__project-name">{{track.project?.name}}</span>
  }

  <mat-form-field appearance="fill" class="track-entry__tags">
    <mat-icon matPrefix class="track-entry__tags-icon">sell</mat-icon>
    <mat-select [multiple]="true" formControlName="selectedTags" class="track-entry__tags-select">
      @for (tag of tags(); track tag.id) {
      <mat-option [value]="tag.id" class="track-entry__tags-option">
        {{ tag.label }}
      </mat-option>
      }
    </mat-select>
  </mat-form-field>

  @if (track.author && showUser()) {
    <mat-icon matPrefix class="track-entry__tags-icon">person</mat-icon>
    {{track.author.name}}
  }

  <div class="track-entry__time">
    <div class="track-entry__time-display">
      <div class="track-entry__time-value">
        <button class="track-entry__date-value" (click)="startPicker.open()" (keydown)="startPicker.open()"
          (focus)="true">{{formatDate(startTime())}}</button>
        <button class="track-entry__hour-value" (click)="startTimePicker.open()"
          (keydown)="startTimePicker.open()">{{formatTimeDisplay(startTime())}}</button>
      </div>
      <div class="track-entry__time-inputs">
        <mat-form-field appearance="fill">
          <mat-label>Start Date</mat-label>
          <input matInput [matDatepicker]="startPicker" formControlName="startDate">
          <mat-datepicker-toggle matIconSuffix [for]="startPicker"></mat-datepicker-toggle>
          <mat-datepicker #startPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>Start Time</mat-label>
          <input matInput [matTimepicker]="startTimePicker" formControlName="startTime">
          <mat-timepicker-toggle matIconSuffix [for]="startTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #startTimePicker></mat-timepicker>
        </mat-form-field>
      </div>
    </div>

    <span class="track-entry__time-separator">-</span>

    <div class="track-entry__time-display">
      <div class="track-entry__time-value">
        <button class="track-entry__date-value" (click)="endPicker.open()"
          (keydown)="endPicker.open()">{{formatDate(endTime())}}</button>
        <button class="track-entry__hour-value" (click)="endTimePicker.open()"
          (keydown)="endTimePicker.open()">{{formatTimeDisplay(endTime())}}</button>
      </div>
      <div class="track-entry__time-inputs">
        <mat-form-field appearance="fill">
          <mat-label>End Date</mat-label>
          <input matInput [matDatepicker]="endPicker" formControlName="endDate">
          <mat-datepicker-toggle matIconSuffix [for]="endPicker"></mat-datepicker-toggle>
          <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

        <mat-form-field appearance="fill">
          <mat-label>End Time</mat-label>
          <input matInput [matTimepicker]="endTimePicker" formControlName="endTime">
          <mat-timepicker-toggle matIconSuffix [for]="endTimePicker"></mat-timepicker-toggle>
          <mat-timepicker #endTimePicker></mat-timepicker>
        </mat-form-field>
      </div>
    </div>
  </div>
  <span class="track-entry__duration">{{formatDuration(endTime().getTime() - startTime().getTime())}}</span>
    @if (track.permissions.delete && track.permissions.update) {
      <app-custom-menu [menuItems]="menuItems" (itemSelected)="operateOverSelectedMenuItem($event)" ></app-custom-menu>
    }
</form>
}

